import { render, staticRenderFns } from "./ViewProductPage.vue?vue&type=template&id=7b66dfc7"
import script from "./ViewProductPage.vue?vue&type=script&lang=js"
export * from "./ViewProductPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports